import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-benefits-cards',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './benefits-cards.html',
  styleUrl: './benefits-cards.scss'
})
export class BenefitsCards {
  s3BaseUrl = environment.s3BaseUrl;
  
  // Estado de la card activa (por defecto es 'membership')
  activeCard: string = 'membership';

  // Datos de las cards de beneficios
  benefits = [
    {
      id: 'membership',
      title: 'Membresías Exclusivas',
      description: 'Acceso ilimitado a 15 hectáreas de diversión. Tu familia, tu paraíso, tu lugar.',
      image: `${this.s3BaseUrl}/images/sections/benefits_card/membership.webp`,
      isMain: true
    },
    {
      id: 'events',
      title: 'Eventos Exclusivos',
      description: 'Acceso prioritario a fiestas temáticas y eventos especiales del resort.',
      image: `${this.s3BaseUrl}/images/sections/benefits_card/exclusive_party.webp`,
      isMain: false
    },
    {
      id: 'access',
      title: 'Acceso Exclusivo',
      description: 'Estacionamiento privado y entrada preferencial para miembros del club.',
      image: `${this.s3BaseUrl}/images/sections/benefits_card/access.webp`,
      isMain: false
    },
    {
      id: 'benefits',
      title: 'Beneficios Generales',
      description: 'Descuentos en restaurantes, spa y actividades adicionales del resort.',
      image: `${this.s3BaseUrl}/images/sections/benefits_card/benefits.webp`,
      isMain: false
    }
  ];

  // Seleccionar una card (no se puede deseleccionar)
  selectCard(cardId: string): void {
    this.activeCard = cardId;
  }

  // Verificar si una card está expandida
  isCardExpanded(cardId: string): boolean {
    return this.activeCard === cardId;
  }

  // Obtener el icono correcto para una card
  getCardIcon(cardId: string): string {
    // Usar siempre la misma imagen, la rotación se hace con CSS
    return `${this.s3BaseUrl}/icons/features/Arrow_up_right.png`;
  }

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
